import { $Q } from '../utils/query-selector';
import { dataToggle } from '../utils/toggle-dataset';
import Swiper from "swiper";
import { Autoplay } from 'swiper/modules';
import { setSidebarMenuPosition } from '../utils/menu';

/**
 * Init tob bar announcement
 */
const initTopBarAnnoucement = () => {
  const isClosedTopBar = localStorage.getItem('is_closed_topbar') || false;
  const topBar = $Q(".top-bar");

  if(!topBar) return;

  const closeTopBarIcon = $Q(".top-bar__close");

  if (isClosedTopBar !== 'true') dataToggle(topBar);

  closeTopBarIcon.addEventListener("click", () => closeTopBar(topBar));
  initTopBarSlider();
  toggleTopBar(topBar);
};
 
/**
 *
 * @param {DOM element} topBar to toggle data-active
 * set true to is_closed_topbar in localStorage in order to hide top bar
 */
const closeTopBar = (topBar) => {
  dataToggle(topBar);
  localStorage.setItem('is_closed_topbar', 'true');
  setSidebarMenuPosition();

  const header = $Q('.jc-header');
  document.documentElement.style.setProperty(
    '--header-bottom-position',
    `${parseInt(header.getBoundingClientRect().bottom)}px`
  );
}

/**
 * This function reads scroll to hide or show top bar
 * @param {HTMLElement} topBar - It is the top bar element
 */
 const toggleTopBar = (topBar) => {
 

  window.addEventListener('scroll', () => {
    if(window.scrollY > 200) {
      topBar.classList.add('top-bar--hidden');
      setSidebarMenuPosition();
    } else if (window.scrollY < 150) {
      topBar.classList.remove('top-bar--hidden');
      setSidebarMenuPosition();
    }
  })
}

/**
 * Init top bar slider
 */
const initTopBarSlider = () => {
  new Swiper(".top-bar", {
    modules: [Autoplay],
    slidesPerView: 1,
    spaceBetween: 40,
    pagination: false,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
  })
}

initTopBarAnnoucement();
